import React from "react";
import { colourClasses } from "@/lib/colours";

// Movement direction chip (in = green, out = rose)
export function MovementDirection({ direction }) {
  const c = colourClasses(direction === "in" ? "green" : "rose");
  return (
    <span className={`inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-[11px] font-semibold ${c.bg} ${c.text} ${c.border} border`}>
      {direction === "in" ? "Stock In" : "Stock Out"}
    </span>
  );
}

const TYPE_COLOUR = {
  supplier_delivery: "green", customer_sale: "rose", allocated_to_job: "amber",
  used_on_installation: "orange", returned_from_job: "teal", customer_return: "teal",
  warehouse_transfer: "indigo", van_transfer: "indigo", damaged: "rose", missing: "rose",
  stocktake_adjustment: "slate", manual_correction: "slate",
};

export function MovementType({ type, label }) {
  const c = colourClasses(TYPE_COLOUR[type] || "slate");
  return <span className={`inline-flex items-center px-2 py-0.5 rounded-md text-[11px] font-medium ${c.bg} ${c.text}`}>{label || type}</span>;
}

export function LocationTypePill({ type }) {
  const map = { warehouse: "indigo", showroom: "purple", van: "teal", engineer_vehicle: "teal", depot: "blue", other: "slate" };
  const c = colourClasses(map[type] || "slate");
  return <span className={`inline-flex items-center px-2 py-0.5 rounded-md text-[11px] font-medium ${c.bg} ${c.text} capitalize`}>{(type || "").replace("_", " ")}</span>;
}
